<template>
  <div
    class="login-form-container d-flex justify-content-center align-items-center"
  >
    <form class="login-form" action="#" @submit.prevent>
      <h2 class="d-none logoFamily">
        www.me&code.com
      </h2>
      <div class="control-group">
        <input
          id="account"
          type="email"
          name="title"
          placeholder="請輸入帳號"
          v-model="user.email"
        />
        <label for="account">帳號</label>
      </div>
      <br />
      <div class="control-group">
        <input
          id="password"
          type="password"
          name="title"
          placeholder="請輸入密碼"
          v-model="user.password"
        />
        <label for="password">密碼</label>
      </div>
      <button class="primary-btn w-100" @click="loginHandler">
        登入
      </button>
      <p class="text-center mt-5 logoFamily">
        © 2020~∞ - www.me&code.com
      </p>
    </form>
  </div>
</template>

<script>
import apiUserLogin from '@/assets/js/api/apiLogin';
import { mapMutations } from 'vuex';
export default {
  data() {
    return {
      user: {
        email: '',
        password: '',
      },
      token: '',
    };
  },
  methods: {
    loginHandler() {
      apiUserLogin(this.user)
        .then(res => {
          const { token, expired, uuid } = res.data;
          let obj = { token, uuid };
          this.SET_USER(obj);
          // 寫入 cookie token
          // expires 設置有效時間
          document.cookie = `token=${token};expires=${new Date(
            expired * 1000,
          )}; path=/`;
          this.$router.push({ name: 'back' });
        })
        .catch(err => {
          this.$fire({
            title: `${err}`,
            type: 'error',
            timer: 3000,
          });
        });
    },
    ...mapMutations([
      'SET_USER', // 将 `SET_USER()` 映射为 `this.$store.commit('SET_USER')`
    ]),
  },
};
</script>
